import { useState, useEffect } from 'react';
import { SimpleAlert } from '../../../../../rbts/helpers';
import { getHistorialRecargas } from '../../../../service/enlistment';
import { HistorialRecargasModel } from '../models/HistorialRecargasModel';

export const useHistorialRecargas = (reloadGrid: number, folio: string) => {
  const [list, setList] = useState<HistorialRecargasModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoadingRequest(true);
      try {
        const res = await getHistorialRecargas(folio);
        setList(Array.isArray(res) ? res : []);
      } catch (error: any) {
        const message = error.response?.data?.message || 'Error al obtener el historial.';
        SimpleAlert(message, 3000, 'error');
      } finally {
        setLoadingRequest(false);
      }
    };
    if (folio !== '') {
      fetchData();
    } else {
      setLoadingRequest(false);
      setList([]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadGrid]);

  return { list, loadingRequest };
};
